import Cookies from 'js-cookie';

import URL from '../constants/URL';
import dataProxy from '../dataProxy';
import * as req from '../utils/req';

export default {
  /**
   * Get User's Email setting
   * @returns {Promise<any>}
   */
  getEmailSettingInfo() {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(`${URL.GET_EMAIL_SETTINGS}/${Cookies.get('locale')}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * Save User's Email Setting
   */
  saveEmailSettingInfo(params) {
    const retVal = true;

    req.doPostData(
      URL.SAVE_EMAIL_SETTINGS,
      params,
      (res) => {
        console.log(res);
      },
      (res) => {
        console.log(res);
      },
      false
    );
    return retVal;
  },
};
